module.exports = __webpack_public_path__ + "img/number5.82895847.jpg";